import axios from "axios";
import config from "../config/config";

const baseUrl = config.baseUrl;

export const UserHistory = async (roitype) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `${baseUrl}/user-roi-history?roitype=` + roitype,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            result: respData.data.result
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

export const StakeHistory = async (roitype) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/staking-history`,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            result: respData.data.result
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

export const ProceedUnstake = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/unstake-plan`,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            },
            'data': data
        });
        return {
            status: respData.data.status,
            txUrl: respData.data.txUrl
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}


function returnErr(err) {
    if (err.response && err.response.data && err.response.data.errors) {
        return err.response.data.errors;
    }
    else {
        return '';
    }
}


